export default {
  quote: null,
  quoteItems: [],
  quoteBookings: [],
  orderQuote: null,
  quoteConfiguration: null,
}
